import { useAtomValue } from "jotai";

import { IsMobileAtom } from "../../App";
import {
  ActionsCloseButton,
  FloatingToolbar,
  IconAction,
} from "../../components/PageView/PageViewTable/SharedToolbar/SharedSelectedRecordsActions";
import useDeleteRecordOperations, {
  operationTypes,
} from "../../api/api-hooks/deletedRecords/DeletedRecordsOperations";

const FloatingToolbarForDeletedRecords = ({
  onClear,
  selectedRecordIds,
}: {
  onClear: () => void;
  selectedRecordIds: string[];
}) => {
  const isMobile = useAtomValue(IsMobileAtom);
  const length = selectedRecordIds?.length;
  const { confirmOperation, performOperation } = useDeleteRecordOperations();

  const handleDeletedRecordOperations = async (operation: operationTypes) => {
    const result = await confirmOperation(operation, length);

    if (!result) return;

    performOperation({
      Operation: operation,
      RecordIDs: selectedRecordIds,
      onSuccess: onClear,
    });
  };

  return (
    <>
      <FloatingToolbar>
        <ActionsCloseButton onClear={onClear} length={length} />
        <div
          className="d-flex align-items-center ml-2"
          style={{ overflowX: "auto" }}
        >
          <IconAction
            icon="file-restore"
            title="Restore"
            isMobile={isMobile}
            onClick={() => handleDeletedRecordOperations("Restore")}
          />
          <IconAction
            icon="file-document-remove"
            title="Delete"
            isMobile={isMobile}
            onClick={() => handleDeletedRecordOperations("Deletion")}
          />
        </div>
      </FloatingToolbar>
    </>
  );
};

export default FloatingToolbarForDeletedRecords;
